import { cn } from '../../../lib/utils'
import React, { ReactNode } from 'react'

function Heading({ children, className }: { children: ReactNode, className?: string }) {
  return (
    <h1 className={cn('text-3xl md:text-4xl font-medium leading-none', className)}>{ children }</h1>
  )
}

export default Heading